import { GET_BILLINGPARTY_REQUEST, GET_BILLINGPARTY_SUCCESS, GET_BILLINGPARTY_FAIL,
    CREATE_BILLINGPARTY_REQUEST, CREATE_BILLINGPARTY_SUCCESS, CREATE_BILLINGPARTY_FAIL,
    UPDATE_BILLINGPARTY_REQUEST, UPDATE_BILLINGPARTY_SUCCESS, UPDATE_BILLINGPARTY_FAIL,
    DELETE_BILLINGPARTY_REQUEST, DELETE_BILLINGPARTY_SUCCESS, DELETE_BILLINGPARTY_FAIL,
    GET_BILLINGPARTYMASTER_REQUEST, GET_BILLINGPARTYMASTER_SUCCESS, GET_BILLINGPARTYMASTER_FAIL, 
} from "../types/billingPartyMasterTypes";



function getBillingPartyReducer( state = { billingParty: []}, action) {
    switch (action.type) {
        case GET_BILLINGPARTY_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_BILLINGPARTY_SUCCESS:
            return {
                ...state,
                billingParty: action.payload,
                isLoading: false
            }       
        case GET_BILLINGPARTY_FAIL :
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}


function createBillingPartyReducer( state = { createBillingParty: {}}, action) {
    switch (action.type) {
        case CREATE_BILLINGPARTY_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case CREATE_BILLINGPARTY_SUCCESS:
            return {
                ...state,
                createBillingParty: action.payload,
                isLoading: false
            }       
        case CREATE_BILLINGPARTY_FAIL :
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function updateBillingPartyReducer( state = { updateBillingParty: {}}, action) {
    switch (action.type) {
        case UPDATE_BILLINGPARTY_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case UPDATE_BILLINGPARTY_SUCCESS:
            return {
                ...state,
                updateBillingParty: action.payload,
                isLoading: false
            }       
        case UPDATE_BILLINGPARTY_FAIL :
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function deleteBillingPartyReducer( state = { deleteBillingParty: {}}, action) {
    switch (action.type) {
        case DELETE_BILLINGPARTY_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case DELETE_BILLINGPARTY_SUCCESS:
            return {
                ...state,
                deleteBillingParty: action.payload,
                isLoading: false
            }       
        case DELETE_BILLINGPARTY_FAIL :
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}


function getBillingPartyBranchReducer( state = { billingPartyMaster: []}, action) {
    switch (action.type) {
        case GET_BILLINGPARTYMASTER_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_BILLINGPARTYMASTER_SUCCESS:
            return {
                ...state,
                billingPartyMaster: action.payload,
                isLoading: false
            }       
        case GET_BILLINGPARTYMASTER_FAIL :
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}


export { getBillingPartyReducer, createBillingPartyReducer, updateBillingPartyReducer, deleteBillingPartyReducer, getBillingPartyBranchReducer }